import { useUserContext } from "../../components/contexts/useUserContext"
import { useState } from "react"
import { useHistory } from "react-router"
import {Container, ProfileCard} from "./style"
import Input from "../../components/Input"
import UserPlaceholder from '../../assets/user-placeholder.png'
import Button from '../../components/Button'
import { Link } from "react-router-dom"
import { api } from "../../services/api"
import { photo } from "../../../src/services/photo"
import {alert} from "../../components/Alert"

function ClientUpdate() {
    const history = useHistory()
    const {user, updateClient, showClient} = useUserContext()
    const [image, setImage] = useState([])
    const [email, setEmail] = useState(user.email)
    const [name, setName] = useState(user.name)
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')

    const changeImage = async (e) => {
        e.preventDefault()
        try{
            const formData = new FormData ()
                formData.append('image[]', image[0])
        

            const response = await api.post(`/clients/add_image/${user.id}`, formData)
            
            if(response.data){
                alert('Foto adicionada', 'success');
                setImage(response.data)
                console.log(response.data)
                showClient()
                
            }
            
        }catch(error){
            alert('Erro, tente novamente', 'error')
    }
  }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (email === ''){
            alert('Insira Email!', 'warn')
        }
        
        await updateClient({
        name: name,
        email
        })

    }

    return (
        <>
        <Container>
                <div className='title'>
                <h1>Editar perfil</h1>
                <h2>Olá, <span>{user? user.name:''}!</span> </h2>

                </div>
            
            <ProfileCard>
                <form onSubmit={changeImage}>
                    <div className='client-info'>
                        <div className='profile-pic'>
                            <img alt="Foto de Perfil" src={user.client_image_url? `${photo.defaults.baseURL +user.client_image_url}`: UserPlaceholder} />
                            <input
                                placeholder='Foto' type='file' name='file' id='file'
                                onChange={(value) => setImage(value.target.files)}
                            />
                        </div>
                    </div>
                    <div className='custom-button'>
                    <Button format='profile' type='submit' className='button'>Confirmar nova foto de perfil</Button>

                    </div>
                </form>
                <form onSubmit={handleSubmit}>

                <div className='client-info'>
                    <Input 
                    label='Nome'
                    type='text'
                    value={name}
                    onChange={value => setName(value.target.value)}
                    />
                </div>

                <div className='client-info'>
                    <Input 
                    label='Email'
                    type='email'
                    value={email}
                    onChange={value => setEmail(value.target.value)}
                    />
                </div>

                <div className='custom-button'>
                    <Button type='submit' format='profile'>Confirmar mudanças</Button>
                </div>

                <Link to='/profile'>
                    <div className='custom-button'>
                        <Button format='profile'>Voltar</Button>
                    </div>
                </Link>

                </form>

            </ProfileCard>  
        </Container>

        </>
    )
}

export default ClientUpdate